<script setup lang="ts">
import { PromotionProps } from "./Promotion.props"

const props = defineProps<PromotionProps>()

const { title, promoId, promoLocation } = toRefs(props)

const dynamicId = computed(() => `link-${Math.random()}`)

const triggerLink = () => navigateTo(props.path)
</script>

<template>
  <GASelectPromotion
    :promoId="promoId ?? ''"
    :title="title ?? ''"
    :promoLocation="promoLocation ?? ''"
    class="h-full cursor-pointer"
    @click="triggerLink"
  >
    <div
      class="
        card-promo-promotion
        flex flex-col
        gap-2
        px-4
        py-5
        md:gap-4
        md:p-2
        md:pb-5
      "
    >
      <UtilsWrapperImage
        v-if="promotionImage"
        v-bind="promotionImage"
        class="wrapper-image-full-container-centered wrapper-image-ratio-auto"
      />

      <AppLink :id="dynamicId" :to="path">
        <p v-if="title" class="md:dolphin-bold pig-bold uppercase">
          {{ title }}
        </p>
      </AppLink>
      <p v-if="subTitle" class="beaver-bold md:pig-bold">
        {{ subTitle }}
      </p>
      <UtilsMarkdown
        v-if="validity"
        :content="$t('pages.promotion.promoCards.untilStockLast')"
        class="mouse-medium md:beaver-medium text-slate-main"
      />
    </div>
  </GASelectPromotion>
</template>
